enum AudienceMergeMode {
  Or = 'or',
  And = 'and',
}

export default AudienceMergeMode;
